const EventEmitter = require('eventemitter3');
const EventBus = new EventEmitter();
export default EventBus;
